import { FC } from "react";
import { StyleProp, StyleSheet, Text, TextStyle, View, ViewStyle } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";

type tEmptyMessageProps = {
  message?: string;
  textStyle?: StyleProp<TextStyle>;
  viewStyle?: StyleProp<ViewStyle>;
};
/**
 * <EmptyMessage /> is a component that renders greyed out text when there is no data to display.
 * The purpose of its encapsulation in a component is to standardize styles
 * @param {string} message The message that will be rendered. If not provided, it will default to "There is nothing to display"
 * @param {StyleProp<TextStyle>} textStyle This will style the <Text /> element
 * @param {StyleProp<ViewStyle>} viewStyle This will style the <View> element surrounding it
 */
const EmptyMessage: FC<tEmptyMessageProps> = ({ message = "There is nothing to display", textStyle, viewStyle }) => {
  return (
    <View style={[styles.container, viewStyle]}>
      <Text style={[styles.text, textStyle]}>{message}</Text>
    </View>
  );
};

export default EmptyMessage;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  text: {
    ...kFonts.bodyItalic,
    color: kColors.mediumGrey,
  },
});
